/* eslint-disable import/no-restricted-paths */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';
import {
  fetchGetUserByRealtyId,
  type TGetUserByRealtyIdResponse,
} from '../../../../node/common/repositories/user-data-aggregation/v1/get-user-by-realty-id';
import { setUserData } from '../../slices';

export const getUserData = createAsyncThunk<void, number | undefined, IThunkApi>(
  'user/getUserData',
  async (realtyUserId, _thunkApi) => {
    if (!realtyUserId) {
      return;
    }

    const {
      dispatch,
      extra: { httpApi, logger },
    } = _thunkApi;

    try {
      const res = (await fetchGetUserByRealtyId({
        httpApi,
        parameters: {
          realtyUserId,
        },
      })) as TGetUserByRealtyIdResponse;

      if (res.statusCode === 200) {
        dispatch(setUserData(res.response.user));
      }
    } catch (e) {
      logger.debug('Ошибка загрузки списка журналов', {
        message: e.message,
        domain: e.domain,
      });

      throw e;
    }
  },
);
